"use strict";

(() => {
  // === web-components ========================================================

  window.customElements.define(
    "z21-accordion",
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("[data-z21-accordion-button]");
        this.content = this.querySelector("[data-z21-accordion-content]");
        this.button.addEventListener("click", this.onButtonClick.bind(this));
      }

      onButtonClick() {
        if (this.content.hidden) {
          const collapsedHeight = this.content.offsetHeight;
          this.content.hidden = false;
          this.button.setAttribute("aria-expanded", "true");
          const expandedHeight = this.content.offsetHeight;

          this.content.animate(
            [
              { height: `${collapsedHeight}px` },
              { height: `${expandedHeight}px` },
            ],
            {
              duration: 300,
              easing: "ease-out",
            },
          );
        } else {
          const expandedHeight = this.content.offsetHeight;
          this.content.hidden = true;
          this.button.setAttribute("aria-expanded", "false");
          const collapsedHeight = this.content.offsetHeight;
          this.content.hidden = false;

          const animation = this.content.animate(
            [
              { height: `${expandedHeight}px` },
              { height: `${collapsedHeight}px` },
            ],
            {
              duration: 300,
              easing: "ease-out",
            },
          );

          animation.onfinish = () => {
            this.content.hidden = true;
          };
        }
      }
    },
  );

  // === end web-components ====================================================

  // === newsletter-pop-up =====================================================

  // Show newsletter pop-up for first time visitor. Show it 30 seconds after page load.

  function autoShowNewsletterPopUp() {
    const firstVisitTime = window.localStorage.getItem("firstVisitTime");

    if (!firstVisitTime) {
      window.localStorage.setItem("firstVisitTime", new Date());

      const sleepTime = 30000; // 30 seconds
      setTimeout(() => {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(["openForm", "5e2967554c7fa41beac24004"]);
      }, sleepTime);
    }
  }

  autoShowNewsletterPopUp();

  // === end newsletter-pop-up =================================================

  // === newsletter-side-button ================================================

  // Add newsletter side button.

  window.customElements.define(
    "newsletter-side-button",
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("[data-newsletter-side-button]");
        this.button.addEventListener("click", this.onButtonClick.bind(this));
      }

      onButtonClick() {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(["openForm", "5e2967554c7fa41beac24004"]);
      }
    },
  );

  // === end newsletter-side-button ============================================

  // === modify-collection-link ================================================

  // Modify collection link for Shogun built pages.

  function modifyCollectionLink() {
    const links = document.querySelectorAll(".shogun-root a");

    for (const link of links) {
      if (
        link.href.includes("/collections/") &&
        !link.href.includes("/products/") &&
        !link.href.includes("filter.v.availability")
      ) {
        const combinator = link.href.includes("?") ? "&" : "?";
        link.href = `${link.href}${combinator}filter.v.availability=1`;
      }
    }
  }

  modifyCollectionLink();

  // === end modify-collection-link ============================================

  // === bundle-accordion ======================================================

  // Add accordion to bundles in product page. Build on top of Selly.

  function addAccordionToBundles() {
    const onBundleShowed = () => {
      const tdfBundle = document.querySelector(".tdf_bundle");
      const bundles = tdfBundle.querySelectorAll(".tdf_bundle_content");
      const charCodeA = "A".charCodeAt(0);
      const anchor = document.createElement("div");

      for (let i = 0; i < bundles.length; ++i) {
        const bundle = bundles[i];
        const bundlePrice = bundle.querySelector(".tdf_bundle_price");
        bundle.insertAdjacentElement("afterbegin", bundlePrice);
        const name = String.fromCharCode(charCodeA + i);
        const id = `bundle-accordion__content-${i}`;

        const accordion = document.createElement("z21-accordion");
        accordion.classList.add("bundle-accordion");

        const accordionButton = document.createElement("button");
        accordionButton.classList.add("bundle-accordion__button");
        accordionButton.type = "button";
        accordionButton.setAttribute("data-z21-accordion-button", "");
        accordionButton.setAttribute("aria-expanded", "false");
        accordionButton.setAttribute("aria-controls", id);
        accordionButton.textContent = `Bundle ${name}`;

        const accordionContent = document.createElement("div");
        accordionContent.classList.add("bundle-accordion__content");
        accordionContent.setAttribute("data-z21-accordion-content", "");
        accordionContent.id = id;
        accordionContent.hidden = true;

        if (i === 0) {
          accordionButton.setAttribute("aria-expanded", "true");
          accordionContent.hidden = false;
        }

        bundle.insertAdjacentElement("beforebegin", anchor);
        accordionContent.append(bundle);
        accordion.append(accordionButton, accordionContent);
        anchor.insertAdjacentElement("beforebegin", accordion);
      }

      anchor.remove();
      tdfBundle.insertAdjacentHTML(
        "afterbegin",
        `<h2 class="tdf_bundle_section_header">Bundles</h2>`,
      );
    };

    const onJsLoadedNfec = (eventName, eventData) => {
      if (eventName !== "jsloaded_nfec") {
        throw new Error(`Unexpected event: ${eventName}`);
      }

      const getNfec = eventData;
      const nfec = getNfec();

      // 3rd argument: should run if event has happend
      // 4th argument: can run more than once
      nfec.event_hub.ListenTo("bundle_showed", onBundleShowed, true, false);
    };

    let tryToRunCount = 20;

    const tryToRun = () => {
      tryToRunCount -= 1;

      if (window.tdfEventHub) {
        // 3rd argument: should run if event has happened
        window.tdfEventHub.ListenToEvent("jsloaded_nfec", onJsLoadedNfec, true);
      } else if (tryToRunCount > 0) {
        const waitTime = 200; // 200 millisecond
        setTimeout(tryToRun, waitTime);
      } else {
        throw new Error("Exceed try limit to adjust bundle section");
      }
    };

    document.head.insertAdjacentHTML(
      "beforeend",
      `
        <style>
          .bundle-accordion {
            display: block;
          }

          .bundle-accordion__button.bundle-accordion__button.bundle-accordion__button {
            position: relative;
            width: 100%;
            border-radius: 0;
            padding: 12px 30px 0 0;
            display: block;
            color: #2b2b2b;
            font-size: 18px !important;
            font-weight: 400 !important;
            line-height: 1.5;
            text-transform: none;
            text-align: left;
          }

          .bundle-accordion__button.bundle-accordion__button.bundle-accordion__button::after {
            content: '';
            position: absolute;
            top: calc(50% - 15px);
            right: 0;
            width: 30px;
            height: 30px;
            display: block;
            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>');
            background-position: center;
            background-size: 30px 30px;
            transform: rotate(90deg);
            transition-property: transform;
            transition-timing-function: ease-out;
            transition-duration: 300ms;
          }

          .bundle-accordion__button.bundle-accordion__button.bundle-accordion__button[aria-expanded="true"]::after {
            transform: rotate(-90deg);
          }

          .bundle-accordion__content.bundle-accordion__content.bundle-accordion__content {
            display: block;
            overflow: hidden;
          }

          .bundle-accordion__content.bundle-accordion__content.bundle-accordion__content[hidden] {
            height: 40px;
          }

          .tdf_bundle_section_header.tdf_bundle_section_header.tdf_bundle_section_header {
            margin-bottom: 16px;
            font-size: 20px;
            font-weight: 700;
          }

          .tdf_bundle_content.tdf_bundle_content.tdf_bundle_content.tdf_bundle_content {
            padding-top: 0;
          }

          .tdf_bundle_message.tdf_bundle_message.tdf_bundle_message.tdf_bundle_message {
            display: none;
          }

          .tdf_bundle_product_container.tdf_bundle_product_container.tdf_bundle_product_container.tdf_bundle_product_container {
            display: flex;
            gap: 16px;
            overflow: auto;
            float: none;
          }

          .tdf_bundle_product_container.tdf_bundle_product_container.tdf_bundle_product_container.tdf_bundle_product_container > .tdf_plus_icon {
            display: none;
          }

          .tdf_bundle_product_item.tdf_bundle_product_item.tdf_bundle_product_item.tdf_bundle_product_item {
            flex: 0 0 180px;
            width: 180px !important;
            display: flex;
          }

          .tdf_vertical_product.tdf_vertical_product.tdf_vertical_product.tdf_vertical_product {
            height: auto !important;
            margin-bottom: 0;
            padding-bottom: 0;
            display: flex;
            flex-direction: column;
          }

          .tdf_vertical_product.tdf_vertical_product.tdf_vertical_product.tdf_vertical_product > .tdf_bundle_img {
            aspect-ratio: 1;
            width: 100%;
            height: auto;
          }

          .tdf_vertical_product.tdf_vertical_product.tdf_vertical_product.tdf_vertical_product .tdf_vertical_title {
            max-height: none;
            display: block;
            -webkit-line-clamp: none;
          }

          .tdf_vertical_product.tdf_vertical_product.tdf_vertical_product.tdf_vertical_product .tdf_bundle_item_bottom {
            position: static;
            flex: 1 0 auto;
            align-items: flex-end;
          }

          .tdf_vertical_product.tdf_vertical_product.tdf_vertical_product.tdf_vertical_product .tdf_bundle_item_bottom .tdf_vertical_price {
            margin-bottom: 3px;
          }

          .tdf_bundle_price.tdf_bundle_price.tdf_bundle_price.tdf_bundle_price {
            margin-left: 0;
            margin-bottom: 15px;
          }

          .tdf_bundle_left.tdf_bundle_left.tdf_bundle_left.tdf_bundle_left {
            margin-top: 16px;
          }
        </style>
      `,
    );

    tryToRun();
  }

  if (
    window.bundleAccordionEnabled &&
    window.location.pathname.includes("/products/")
  ) {
    addAccordionToBundles();
  }

  // === end bundle-accordion ==================================================
})();
